import React, { useState, useEffect, useMemo } from 'react'
import Card from 'react-bootstrap/Card';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify'

const Red = _ => {
    const [isProcessing, setIsProccesing] = useState(true)
    const [rows, setRows] = useState([])

    useEffect(() => {
        setIsProccesing(true)
        Controllers.red.get_my_red().then(res => {
            setRows(res.data)
        }).catch(req => Helpers.promise.catch({ req, toast }))
        .finally(() => {
            setIsProccesing(false)
        })
    }, [])

    const summary = useMemo(() => {
        const active = rows.filter(r => parseInt(r.id_status) === 1).length
        const inactive = rows.length - active
        const levels = new Set(rows.map(r => r.nivel)).size
        return { total: rows.length, active, inactive, levels }
    }, [rows])

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                { name: 'id_customers', text: 'ID', align: 'center', sort: false },
                { name: 'id_upline', text: 'Upline', align: 'center', sort: false },
                { name: 'id_sponsor', text: 'Sponsor', align: 'center', sort: false },
                { name: 'full_name', text: 'Nombres', sort: false },
                { name: 'nivel', text: 'Nivel', align: 'center', sort: false },
                { name: 'name_plan', text: 'Rango', align: 'center', sort: false },
                { name: 'date_registration', text: 'Fecha de Ingreso', align: 'center', sort: false },
                { name: 'point_current_customers', text: 'Puntos', align: 'center', sort: false },
                { name: 'point_business_customers', text: 'Valor Negocio', align: 'center', sort: false },
                { name: 'id_status', text: 'Estatus', align: 'center', sort: false, render: r => <div className={'badge badge-' + (parseInt(r.id_status) === 1 ? 'success' : 'danger')}>
                    {parseInt(r.id_status) === 1 ? 'Activo' : 'De Baja'}
                </div> },
                { name: 'key_branch_office', text: 'Sucursal', align: 'center', sort: false },
                { name: 'code_country', text: 'País', align: 'center', sort: false },
            ],
        ]}
        rows={rows}
        pageLength={100}
        isProcessing={isProcessing}
        noSort
    />, [rows, isProcessing])

    return <div className="ui-page">
        <div className="ui-page-head">
            <div>
                <h1 className="ui-page-title">Mi Red</h1>
                <p className="ui-page-meta">Descendencia y estatus de consultores</p>
            </div>
        </div>
        {!isProcessing ? <div className="ui-summary-strip">
            <Card className="ui-metric-card mb-0">
                <Card.Body className="text-center py-3">
                    <span className="ui-metric-label">Total red</span>
                    <div className="ui-metric-value">{summary.total}</div>
                </Card.Body>
            </Card>
            <Card className="ui-metric-card mb-0">
                <Card.Body className="text-center py-3">
                    <span className="ui-metric-label">Activos</span>
                    <div className="ui-metric-value">{summary.active}</div>
                </Card.Body>
            </Card>
            <Card className="ui-metric-card mb-0">
                <Card.Body className="text-center py-3">
                    <span className="ui-metric-label">De baja</span>
                    <div className="ui-metric-value">{summary.inactive}</div>
                </Card.Body>
            </Card>
            <Card className="ui-metric-card mb-0">
                <Card.Body className="text-center py-3">
                    <span className="ui-metric-label">Niveles</span>
                    <div className="ui-metric-value">{summary.levels}</div>
                </Card.Body>
            </Card>
        </div> : null}
        <Card className="ui-list-shell border-0">
            <Card.Header>
                <span>Descendencia de Red</span>
            </Card.Header>
            <Card.Body>
                { dtRows }
            </Card.Body>
        </Card>
    </div>
}

export default Red
